const FONT =
  "'Pretendard','Spoqa Han Sans Neo','Apple SD Gothic Neo','Noto Sans KR',sans-serif";

// ECHO 시안 01 — 지문 핵심 정리 pane
//
// 삽화는 **지문에 달려 있다**(`Paragraph.illustration_url`). 한 지문에 한 장이라
// 섹션마다 같은 주소를 베껴 담지 않는다. 출제할 때 서버가 지인에듀에서 받아 우리
// 저장소에 올려 둔 것이라 학생은 로그인 없이 그냥 연다.
const SummaryPage = ({ section, paragraph, isMobile = false, onComplete }) => {
  const d = section?.question?.data || {};
  const imageSrc =
    paragraph?.illustration_url ||
    d.image_url ||
    d.image ||
    d.illustration ||
    null;
  const rows = [
    ["제목", d.title],
    ["주제", d.topic],
    ["목적", d.purpose],
    ["세 줄 요약", d.three_sentence_summary],
  ].filter(([, v]) => v);

  const thStyle = {
    width: isMobile ? "72px" : "90px",
    backgroundColor: "#F2FAF8", // --teal-mist
    color: "#00A396", // --teal-deep
    fontWeight: 800,
    fontSize: isMobile ? "13px" : "14px",
    padding: isMobile ? "9px 8px" : "10px 12px",
    border: "1px solid #E6EDEC", // --line
    textAlign: "center",
    verticalAlign: "middle",
  };
  const tdStyle = {
    padding: isMobile ? "9px 10px" : "10px 14px",
    border: "1px solid #E6EDEC",
    color: "#3A434E", // --ink-70
    fontSize: isMobile ? "14px" : "15px",
    lineHeight: 1.7,
  };

  return (
    <div
      style={{
        width: "100%",
        maxWidth: "760px",
        margin: "0 auto",
        fontFamily: FONT,
        backgroundColor: "#fff",
        border: "1px solid #E6EDEC",
        borderRadius: "14px",
        overflow: "hidden",
      }}
    >
      {/* 시안 01 pane header(ph) */}
      <div
        style={{
          padding: "10px 16px",
          borderBottom: "1px solid #E6EDEC",
          fontSize: "13px",
          fontWeight: 800,
          letterSpacing: "0.06em",
          color: "#00A396",
        }}
      >
        지문 핵심 정리
      </div>

      <div style={{ padding: isMobile ? "12px" : "16px 18px" }}>
        {imageSrc && (
          <>
            {/* 시안 01 삽화 — 탭/클릭 시 원본 크게 보기 */}
            <img
              src={imageSrc}
              alt="지문 핵심 정리 삽화"
              onClick={() => window.open(imageSrc, "_blank")}
              style={{
                width: "100%",
                borderRadius: "10px",
                border: "1px solid #E6EDEC",
                cursor: "pointer",
                display: "block",
              }}
            />
            {isMobile && (
              <p
                style={{
                  textAlign: "center",
                  fontSize: "11px",
                  color: "#7A8490",
                  margin: "6px 0 2px",
                }}
              >
                이미지를 탭하면 크게 볼 수 있어요
              </p>
            )}
          </>
        )}

        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            marginTop: imageSrc ? "10px" : "0",
          }}
        >
          <tbody>
            {rows.map(([key, value]) => (
              <tr key={key}>
                <th style={thStyle}>{key}</th>
                <td style={tdStyle}>
                  {key === "세 줄 요약"
                    ? String(value)
                        .split("\n")
                        .map((line, i) => (
                          <div key={i} style={{ marginBottom: "4px" }}>
                            {line}
                          </div>
                        ))
                    : value}
                </td>
              </tr>
            ))}
          </tbody>
        </table>

        {/* 시안 01 pfoot — 우측 하단 "학습 시작하기 →" (완료 → 다음 단계) */}
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            paddingTop: "14px",
          }}
        >
          <button
            onClick={onComplete}
            style={{
              backgroundColor: "#0E141B", // cur-submit
              color: "#fff",
              border: "none",
              borderRadius: "999px",
              padding: isMobile ? "11px 0" : "10px 28px",
              width: isMobile ? "100%" : "auto",
              fontSize: "15px",
              fontWeight: 700,
              cursor: "pointer",
            }}
          >
            학습 시작하기 →
          </button>
        </div>
      </div>
    </div>
  );
};

export default SummaryPage;
